import { render, staticRenderFns } from "./TJSQB.vue?vue&type=template&id=6773e6b1&scoped=true"
import script from "./TJSQB.vue?vue&type=script&lang=js"
export * from "./TJSQB.vue?vue&type=script&lang=js"
import style0 from "./TJSQB.vue?vue&type=style&index=0&id=6773e6b1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773e6b1",
  null
  
)

export default component.exports